<style scoped lang="scss" type="text/scss">
    .plain-tag-container {
        width: 3rem;
        height: 1.5rem;
        box-sizing: border-box;
        font-size: .75rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: .15rem;
        border: 1px solid;
    }
</style>

<template>
    <div class="plain-tag-container" :style="{color: textColor, 'border-color': borderColor, 'background-color': bgColor}">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: '',
        props: [
            'bgColor', 'borderColor', 'textColor'
        ],
        data () {
            return {};
        }
    };
</script>
